export enum  DocumentTypeEnum {
  Other=0,
  Quizz=1
}

export interface DocumentInterface {
  documentId: number;
  documentType: DocumentTypeEnum;
  name: string;
  createdAt: Date;
}